/**
 * About 4 — Mega footer (IIT Kharagpur): gradient band, 3 columns, bordered section titles.
 * Dynamic content via metadata rows (column + row type).
 */

export const ABOUT_4_SEED_METADATA = [
  {
    id: "1",
    column_index: "1",
    row_type: "section_heading",
    section_title: "About Us",
    link_text: "",
    link_href: "",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 1,
  },
  {
    id: "2",
    column_index: "1",
    row_type: "link",
    section_title: "",
    link_text: "About Us",
    link_href: "/about",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 2,
  },
  {
    id: "3",
    column_index: "1",
    row_type: "link",
    section_title: "",
    link_text: "Contact Us",
    link_href: "/contact",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 3,
  },
  {
    id: "4",
    column_index: "1",
    row_type: "link",
    section_title: "",
    link_text: "Recognition",
    link_href: "/recognition",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 4,
  },
  {
    id: "5",
    column_index: "1",
    row_type: "section_heading",
    section_title: "Follow Us",
    link_text: "",
    link_href: "",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 5,
  },
  {
    id: "6",
    column_index: "1",
    row_type: "social_icon",
    section_title: "",
    link_text: "",
    link_href: "https://facebook.com",
    rich_html: "",
    icon: "",
    icon_alt: "Facebook",
    kv_label: "",
    kv_value: "",
    priority: 6,
  },
  {
    id: "7",
    column_index: "1",
    row_type: "social_icon",
    section_title: "",
    link_text: "",
    link_href: "https://instagram.com",
    rich_html: "",
    icon: "",
    icon_alt: "Instagram",
    kv_label: "",
    kv_value: "",
    priority: 7,
  },
  {
    id: "8",
    column_index: "1",
    row_type: "social_icon",
    section_title: "",
    link_text: "",
    link_href: "https://wa.me/",
    rich_html: "",
    icon: "",
    icon_alt: "WhatsApp",
    kv_label: "",
    kv_value: "",
    priority: 8,
  },
  {
    id: "9",
    column_index: "1",
    row_type: "section_heading",
    section_title: "Disclaimer",
    link_text: "",
    link_href: "",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 9,
  },
  {
    id: "10",
    column_index: "1",
    row_type: "rich_text",
    section_title: "",
    link_text: "",
    link_href: "",
    rich_html:
      "<p>Precautions to be taken by the students before enrolling in Programmes offered under Open & Distance Learning (ODL) and/or Online Learning (OL) mode.</p>",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 10,
  },
  {
    id: "11",
    column_index: "2",
    row_type: "section_heading",
    section_title: "Bachelors Programs",
    link_text: "",
    link_href: "",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 11,
  },
  {
    id: "12",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "BCA",
    link_href: "/programs/bca",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 12,
  },
  {
    id: "13",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "BBA Business Analytics",
    link_href: "/programs/bba-business-analytics",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 13,
  },
  {
    id: "14",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "BBA",
    link_href: "/programs/bba",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 14,
  },
  {
    id: "15",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "BA JMC",
    link_href: "/programs/ba-jmc",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 15,
  },
  {
    id: "16",
    column_index: "2",
    row_type: "section_heading",
    section_title: "Masters Programs",
    link_text: "",
    link_href: "",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 16,
  },
  {
    id: "17",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "MBA",
    link_href: "/programs/mba",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 17,
  },
  {
    id: "18",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "MBA in Business Analytics",
    link_href: "/programs/mba-business-analytics",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 18,
  },
  {
    id: "19",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "MA JMC",
    link_href: "/programs/ma-jmc",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 19,
  },
  {
    id: "20",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "MA English",
    link_href: "/programs/ma-english",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 20,
  },
  {
    id: "21",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "MA Economics",
    link_href: "/programs/ma-economics",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 21,
  },
  {
    id: "22",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "MSc Data Science",
    link_href: "/programs/msc-data-science",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 22,
  },
  {
    id: "23",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "MSc Mathematics",
    link_href: "/programs/msc-mathematics",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 23,
  },
  {
    id: "24",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "MCA",
    link_href: "/programs/mca",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 24,
  },
  {
    id: "25",
    column_index: "2",
    row_type: "section_heading",
    section_title: "Academics",
    link_text: "",
    link_href: "",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 25,
  },
  {
    id: "26",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "Live Session Tab",
    link_href: "/academics/live-sessions",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 26,
  },
  {
    id: "27",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "Discussion Form",
    link_href: "/academics/discussion",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 27,
  },
  {
    id: "28",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "Course Conduction",
    link_href: "/academics/conduction",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 28,
  },
  {
    id: "29",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "Assessments",
    link_href: "/academics/assessments",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 29,
  },
  {
    id: "30",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "Online Admission Process and Instructions",
    link_href: "/admissions/online-process",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 30,
  },
  {
    id: "31",
    column_index: "2",
    row_type: "link",
    section_title: "",
    link_text: "Mandatory Disclosure",
    link_href: "/mandatory-disclosure",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 31,
  },
  {
    id: "32",
    column_index: "3",
    row_type: "section_heading",
    section_title: "Admission",
    link_text: "",
    link_href: "",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 32,
  },
  {
    id: "33",
    column_index: "3",
    row_type: "link",
    section_title: "",
    link_text: "Admission Policy",
    link_href: "/admissions/policy",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 33,
  },
  {
    id: "34",
    column_index: "3",
    row_type: "link",
    section_title: "",
    link_text: "Online Admission Portal",
    link_href: "/admissions/portal",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 34,
  },
  {
    id: "35",
    column_index: "3",
    row_type: "link",
    section_title: "",
    link_text: "Sample Certificate",
    link_href: "https://example.com/sample-certificate",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 35,
  },
  {
    id: "36",
    column_index: "3",
    row_type: "link",
    section_title: "",
    link_text: "Myaccount",
    link_href: "/account",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 36,
  },
  {
    id: "37",
    column_index: "3",
    row_type: "link",
    section_title: "",
    link_text: "Cancellation Form",
    link_href: "https://example.com/cancellation.pdf",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 37,
  },
  {
    id: "38",
    column_index: "3",
    row_type: "section_heading",
    section_title: "Contact Us",
    link_text: "",
    link_href: "",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 38,
  },
  {
    id: "39",
    column_index: "3",
    row_type: "key_value",
    section_title: "",
    link_text: "",
    link_href: "",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "Admission Email:",
    kv_value: "admissions@example.edu.in",
    priority: 39,
  },
  {
    id: "40",
    column_index: "3",
    row_type: "rich_text",
    section_title: "",
    link_text: "",
    link_href: "",
    rich_html:
      "<p>IIT Kharagpur<br/>Kharagpur, West Bengal (INDIA)</p>",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 40,
  },
  {
    id: "41",
    column_index: "3",
    row_type: "key_value",
    section_title: "",
    link_text: "",
    link_href: "",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "Phone number :",
    kv_value: "1800 000 0000",
    priority: 41,
  },
];

export const ABOUT_4_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Footer rows (dynamic)",
  },

  DEFAULT_ROW: {
    id: "1",
    column_index: "1",
    row_type: "link",
    section_title: "",
    link_text: "Link label",
    link_href: "/",
    rich_html: "",
    icon: "",
    icon_alt: "",
    kv_label: "",
    kv_value: "",
    priority: 1,
  },

  ABOUT_FIELDS_CONFIG: [
    {
      fieldName: "status",
      label: "Section status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: false,
    },
    {
      fieldName: "footer_gradient_start_color",
      label: "Gradient start colour",
      value: "#2E1C81",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#2E1C81",
    },
    {
      fieldName: "footer_gradient_end_color",
      label: "Gradient end colour",
      value: "#15094C",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#15094C",
    },
    {
      fieldName: "footer_gradient_angle",
      label: "Gradient angle (deg)",
      value: "147.3",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 147.3",
      required: false,
      defaultValue: "147.3",
    },
    {
      fieldName: "footer_gradient_stop_1",
      label: "First colour stop (%)",
      value: "18",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "18",
    },
    {
      fieldName: "footer_gradient_stop_2",
      label: "Second colour stop (%)",
      value: "58",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "58",
    },
    {
      fieldName: "footer_accent_border_color",
      label: "Section title underline colour",
      value: "#346491",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#346491",
    },
    {
      fieldName: "footer_text_color",
      label: "Default text colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "footer_copyright_html",
      label: "Copyright line (rich text)",
      value:
        "<p>© Copyright 2026 of IIT Kharagpur | All Rights Reserved | <a href=\"/privacy\">Privacy Policy</a></p>",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      required: false,
      defaultValue:
        "<p>© Copyright 2026 of IIT Kharagpur | All Rights Reserved | <a href=\"/privacy\">Privacy Policy</a></p>",
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Column",
      fieldName: "column_index",
      value: "1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Column",
      options: [
        { label: "Left", value: "1" },
        { label: "Middle", value: "2" },
        { label: "Right", value: "3" },
      ],
    },
    {
      header: "Row type",
      fieldName: "row_type",
      value: "link",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Type",
      options: [
        { label: "Section heading", value: "section_heading" },
        { label: "Link", value: "link" },
        { label: "Rich text block", value: "rich_text" },
        { label: "Social icon", value: "social_icon" },
        { label: "Label + value (contact lines)", value: "key_value" },
      ],
    },
    {
      header: "Section title",
      fieldName: "section_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "For “Section heading” rows",
    },
    {
      header: "Link text",
      fieldName: "link_text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "For “Link” rows",
    },
    {
      header: "Link URL",
      fieldName: "link_href",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://… or /path",
    },
    {
      header: "Rich HTML",
      fieldName: "rich_html",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "For “Rich text” rows",
    },
    {
      header: "Icon",
      fieldName: "icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "For “Social icon” rows",
    },
    {
      header: "Icon alt",
      fieldName: "icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Accessibility label",
    },
    {
      header: "KV label",
      fieldName: "kv_label",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Admission Email:",
    },
    {
      header: "KV value",
      fieldName: "kv_value",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "e.g. email or phone",
    },
    {
      header: "Order",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Sort order (lower first)",
      required: true,
    },
  ],
};
